import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { pluck } from 'rxjs/operators';
import { APP_CONFIG } from 'src/app/core/services/config.service';

// declare global to add FB namespace
declare global {
  interface Window {
    fbAsyncInit: () => void;
  }

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const FB: any;
}

@Injectable({
  providedIn: 'root',
})
export class FacebookService {
  constructor() {
    APP_CONFIG()
      .pipe(pluck('facebookClientId'))
      .subscribe((facebookId: string) => this.init(facebookId));
  }

  public login() {
    return new Observable((subscriber) => {
      FB.login(
        (response) => {
          if (response.status === 'connected') {
            subscriber.next(response);
            subscriber.complete();
          } else {
            subscriber.complete();
          }
        },
        { scope: 'public_profile,email' },
      );
    });
  }

  private init(facebookId: string) {
    window.fbAsyncInit = () => {
      FB.init({
        appId: facebookId,
        cookie: true,
        xfbml: true,
        version: 'v13.0',
      });
    };
    (function (d, s, id) {
      const fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        return;
      }
      const js = d.createElement(s) as HTMLScriptElement;
      js.id = id;
      js.src = 'https://connect.facebook.net/en_US/sdk.js';
      fjs.parentNode.insertBefore(js, fjs);
    })(document, 'script', 'facebook-jssdk');
  }
}
